import React from "react";
import moment from "moment";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import Config from "./config";
import { roles } from "./lib/constants";
import { indianNSConverter } from "./shared/methods/indianNSConverter";
import "./styles/main.css";

export const LOGIN_TOKEN = "api/v1/google/token?webRequest=true";
export const LOGIN_AUTHENTICATION = "api/v1/google/secure_authenticated/new";
export const SEND_OTP = "api/v1/signin/sendOtp";
export const VALIDATE_OTP = "api/v1/signin/validateOtp";
export const LOGOUT_USER = "api/v1/google/logout/new";
export const AUTH_TOKEN = "oauth/token";
export const { BASE_URL } = Config.NEW_API;
export const { NEW_BASE_URL } = Config.NEW_API;
export const { AFCS_BASE_URL } = Config.NEW_API;

export const expenseList = {
  conductorIncentives: { displayName: "Conductor Incentives" },
  driverIncentives: { displayName: "Driver Incentives" },
  staffFuel: { displayName: "Staff Fuel" },
  conductorAdvance: { displayName: "Conductor Advance" },
  driverAdvance: { displayName: "Driver Advance" },
  challan: { displayName: "Challan" },
  tollTax: { displayName: "Toll Tax" },
  maintenance: { displayName: "Maintenance" },
  conductorSalary: { displayName: "Conductor Salary" },
  driverSalary: { displayName: "Driver Salary" },
  fuelExpenses: { displayName: "Fuel Expenses" },
  officeExpenses: { displayName: "Office Expenses" },
  stationary: { displayName: "Stationary" },
  miscExpenses: { displayName: "Misc Expenses" },
  accidentalSettlements: { displayName: "Accidental Settlements" },
  busCleaning: { displayName: "Bus Cleaning" },
  cardPassRefund: { displayName: "Card/Pass Refund" },
  conductorOvertime: { displayName: "Conductor Overtime" },
  driverOvertime: { displayName: "Driver Overtime" },
  rtoExpenses: { displayName: "RTO Expenses" },
  busEmi: { displayName: "Bus EMI" },
};

export const passRevenueDetails = {
  superSaverPassRevenue: { displayName: "Super Saver Pass" },
  magicPassRevenue: { displayName: "Magic Pass" },
};

export const templateStrings = {
  busDetailDayWise: {
    fromDate: { displayName: "Date", sortable: true },
    operatorName: { displayName: "Operator Name", sortable: true },
    totalCollection: { displayName: "Total Collection (Rs.)", sortable: true },
    balanceLoaded: { displayName: "Money loaded", sortable: true },
    walletUsage: { displayName: "Digital Consumption", sortable: true },
    expense: { displayName: "Chalo's Expenses", sortable: true },
    finalProfit: {
      displayName: "Gross Contribution",
      sortable: true,
      subText: (row) => (row?.finalProfit !== row?.editedFinalProfit && (
        <div className="grey-hash-text font-size-14">
          {`Adjusted : ₹${indianNSConverter(row.lastGcUpdatedValue)}, ${moment(row.lastGcUpdated).format("DD MMM YYYY")}`}
        </div>
      )
      ),
    },
    totalGcEdit: {
      displayName: "GC adjusted",
      sortable: true,
      subText: (row, context) => (row.totalGcEdit !== 0 ? (
        <div className="flex align-items-center">
          <div
            role="button"
            tabIndex={0}
            className="view-details-button"
            onClick={(e) => {
              e.stopPropagation();
              context?.handleGcLedgerOpen(row);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                context?.handleGcLedgerOpen(row);
              }
            }}
          >
            View details
          </div>
          <div className="flex align-items-center">
            <ChevronRightIcon style={{ fontSize: 20, color: "#F57C00", fontWeight: "1200" }} />
          </div>
        </div>
      ) : null),
    },
    netPayout: { displayName: "Operator's Take", sortable: true },
    operatorExpense: { displayName: "Operator's Exp", sortable: true },
    totalPassengerCount: { displayName: "Total Passenger", sortable: true },
    numberOfTrips: "Trip count",
    totalGpsDistance: { displayName: "Distance Traveled (KM)", sortable: true },
    borneBy: { displayName: "Collection Handled", is_capital: true },
    contractExist: "Contract Status",
    waybillStatus: "Waybill Status",
    status: "Bus Status",
    settled: "Settlement Status",
  },
  // DateDueWise table constants
  dateDetailDayWise: {
    busNumber: { displayName: "Bus Number" },
    fromDate: { displayName: "Travel Date" },
    moneyLoaded: { displayName: "Money Loaded" },
    walletUsage: { displayName: "Digital Consumption" },
    cardDigitalCollection: { displayName: "Digital Collection (Card)" },
    mobileDigitalCollection: { displayName: "Digital Collection (Mobile)" },
    flatFeeShare: { displayName: "Flat Fee" },
    revenueShare: { displayName: "Rev Share" },
    baselineShare: { displayName: "Baseline" },
    digitalDiscountByChalo: { displayName: "Chalo Discount Share" },
    pgFee: { displayName: "PG Fee" },
    netDueAmount: { displayName: "Net Due" },
  },
  operatorViewDayWise: {
    fromDate: { displayName: "Date", sortable: true },
    operatorName: { displayName: "Operator Name", sortable: true },
    totalCollection: { displayName: "Collection", sortable: true },
    balanceLoaded: { displayName: "Money loaded", sortable: true },
    walletUsage: { displayName: "Digital Consumption", sortable: true },
    totalPassengerCount: { displayName: "Total Passenger", sortable: true },
    operatorExpense: { displayName: "Expense", sortable: true },
    waybillStatus: "Data Sync",
  },
  dayWise: {
    fromDate: { displayName: "Date", sortable: true },
    totalBuses: { displayName: "Total Buses", sortable: true },
    totalCollection: { displayName: "Total Ticket Collection (Rs.)", sortable: true },
    totalPassengers: { displayName: "Ridership", sortable: true },
    balanceLoaded: { displayName: "Money loaded", sortable: true },
    walletUsage: { displayName: "Digital Consumption", sortable: true },
    finalProfit: { displayName: "Gross Contribution", sortable: true },
    netPayout: { displayName: "Operator's Take", sortable: true },
  },
  dayWiseCardCollection: {
    fromDate: { displayName: "Date", sortable: true },
    balanceLoaded: { displayName: "Money loaded", sortable: true },
    walletUsage: { displayName: "Digital Consumption", sortable: true },
    netPayout: { displayName: "Net Payout", sortable: true },
  },
  vehicleWise: {
    busNumber: { displayName: "Bus Number", sortable: true },
    totalCollection: { displayName: "Ticket Collection", sortable: true },
    totalPassengerCount: { displayName: "Ridership", sortable: true },
    balanceLoaded: { displayName: "Money loaded", sortable: true },
    walletUsage: { displayName: "Digital Consumption", sortable: true },
    finalProfit: { displayName: "Gross Contribution", sortable: true },
    netPayout: { displayName: "Operator's Take", sortable: true },
    contractStatus: { displayName: "Contract Status" },
    action: "Action",
  },
  operatorViewVehicleWise: {
    busNumber: { displayName: "Bus Number", sortable: true },
    totalCollection: { displayName: "Total Collection", sortable: true },
    totalPassengerCount: { displayName: "Ridership", sortable: true },
    balanceLoaded: { displayName: "Money loaded", sortable: true },
    walletUsage: { displayName: "Digital Consumption", sortable: true },
    expense: { displayName: "Expenses", sortable: true },
    operatorWiseNetPayout: { displayName: "Net Due", sortable: true },
    action: "Action",
  },
  agencyViewVehicleWise: {
    busNumber: { displayName: "Bus Number", sortable: true },
    totalCollection: { displayName: "Total Collection", sortable: true },
    totalPassengerCount: { displayName: "Ridership", sortable: true },
    balanceLoaded: { displayName: "Money loaded", sortable: true },
    walletUsage: { displayName: "Digital Consumption", sortable: true },
    agencyWiseNetPayout: { displayName: "Net Due", sortable: true },
    // expense: { displayName: "Expenses", sortable: true },
    action: "Action",
  },
  issueTicketList: {
    ticketTime: { displayName: "Time" },
    transactionid: { displayName: "Transaction Id" },
    px_total_amount: { displayName: "Spent Amount" },
    conductorName: { displayName: "Conductor Id" },
    actionType: { displayName: "Action Type", defaultValue: "ticket" },
  },
  issueCardList: {
    issuedDate: { displayName: "Time" },
    transactionId: { displayName: "Transaction Id" },
    cardId: { displayName: "Card Id", is_encrypt: true },
    issuedAmount: { displayName: "Load Amount" },
    cardFee: { displayName: "Issuance Fee" },
    tax: { displayName: "Tax Amount" },
    paidAmount: { displayName: "Paid Amount" },
    issuedBy: { displayName: "Conductor Id" },
  },
  rechargeCardList: {
    rechargeDate: { displayName: "Time" },
    transactionId: { displayName: "Transaction Id" },
    cardId: { displayName: "Card Id", is_encrypt: true },
    rechargeAmount: { displayName: "Recharge Amount" },
    tax: { displayName: "Tax Amount" },
    paidAmount: { displayName: "Paid Amount" },
    rechargedBy: { displayName: "Conductor Id" },
  },
  vehicleWiseCardCollection: {
    busNumber: { displayName: "Bus Number", sortable: true },
    balanceLoaded: { displayName: "Money loaded", sortable: true },
    walletUsage: { displayName: "Digital Consumption", sortable: true },
    netPayout: { displayName: "Net Payout", sortable: true },
  },
  contract: {
    busNumber: "Bus Number",
    cityName: { displayName: "City Name", is_capital: true },
    operatorName: { displayName: "Operator Name", is_capital: true },
    typeOfContract: "Type of Contract",
    subscriptionPlan: { displayName: "Subscription Plan" },
    fromDate: { displayName: "Start Date", sortable: true },
    toDate: { displayName: "End Date", sortable: true },
    status: { displayName: "Status" },
    action: "Action",
  },
  currentDues: {
    busNumber: "Bus Number",
    netDueAmount: "Due Amount",
    action: "Action",
  },
  distanceReport: {
    fromDate: { displayName: "Travel Date", sortable: true, do_not_convert_date: true },
    busNumber: { displayName: "Bus Number" },
    totalGpsDistance: { displayName: "Gps Distance (KM)", sortable: true },
    settlementDistance: { displayName: "Settlement Distance (KM)", sortable: true },
  },
  reportDistance: {
    cityName: { displayName: "City" },
    agencyName: { displayName: "Agency" },
    monthYear: { displayName: "Month'Year" },
    totalGpsDistance: { displayName: "Gps Distance (KM)" },
    settlementDistance: { displayName: "Settlement Distance (KM)" },
    action: { displayName: "Action" },
  },
  reportExpense: {
    date: { displayName: "Date" },
    cityName: { displayName: "City" },
    operatorName: { displayName: "Operator Name" },
    totalExpense: { displayName: "Total Expense" },
    ...expenseList,
    action: { displayName: "Action" },
  },
  reportPassRevenue: {
    ymd: { displayName: "Date" },
    cityName: { displayName: "City" },
    operatorName: { displayName: "Operator Name" },
    ...passRevenueDetails,
    action: { displayName: "Action" },
  },
  operatorConfig: {
    operatorName: { displayName: "Operator Name" },
    operatorId: { displayName: "Operator Id" },
    cycleType: { displayName: "Settlement Cycle" },
    action: { displayName: "Action" },
  },
  reportMobileTickets: {
    cityName: { displayName: "City" },
    monthYear: { displayName: "Month'Year" },
    ticketSold: { displayName: "Tickets Sold (₹)" },
    mobileTicketAmount: { displayName: "Tickets scanned (₹)" },
    unusedTicket: { displayName: "Unused tickets (₹)" },
    settleUnused: { displayName: "Action" },
    action: { displayName: " " },
  },
  reportMobileTicketsDetails: {
    cityName: { displayName: "City" },
    fromDate: { displayName: "Date" },
    ticketSold: { displayName: "Tickets Sold (₹)" },
    mobileTicketAmount: { displayName: "Tickets scanned (₹)" },
    unusedTicket: { displayName: "Unused tickets (₹)" },
  },
  reportMobileSettlementDetails: {
    date: { displayName: "Date" },
    cityName: { displayName: "City" },
    agencyName: { displayName: "Agency" },
    operatorName: { displayName: "Operator" },
    settlementDistance: { displayName: "Distance" },
    amountDistributed: { displayName: "Amount" },
  },

  reportPass: {
    cityName: { displayName: "City" },
    monthYear: { displayName: "Month'Year" },
    passRevenue: { displayName: "Pass Revenue (₹)" },
    action: { displayName: " " },
  },
  reportPassDetails: {
    cityName: { displayName: "City" },
    fromDate: { displayName: "Date" },
    passRevenue: { displayName: "Pass Revenue (₹)" },
    action: { displayName: "Action" },
  },
  passRevenueDistribution: {
    productVariant: { displayName: "Product Type" },
    productConfigType: { displayName: "Platform" },
    noOfPassRecognized: { displayName: "Recognised Passes" },
    passRevenue: { displayName: "Pass Revenue (₹)" },
  },

  reportPassSettlement: {
    cityName: { displayName: "City" },
    monthYear: { displayName: "Month'Year" },
    passRevenue: { displayName: "Pass Revenue (₹)" },
    settleUnused: { displayName: "Action" },
    action: { displayName: " " },
  },

  reportOperatorWise: {
    cityName: { displayName: "City" },
    agencyName: { displayName: "Agency" },
    operatorName: { displayName: "Operator" },
    exitBuses: { displayName: "Exit Buses" },
    averageBuses: { displayName: "Average Buses" },
    totalCollection: { displayName: "Ticket Collection" },
    walletUsage: { displayName: "Digital Consumption" },
    totalRidership: { displayName: "Total Rides" },
    digitalRidership: { displayName: "Digital Rides" },
    epkm: { displayName: "EPKM" },
  },

  currentDueVehicleList: {
    // busNumber: "Bus Number",
    // contractualDate: "Contractual Date",
    // digitalDate: "Digital Date",
    // // fromDate: "Start Date",
    // // toDate: "End Date",
    // operatorDueAmount: { displayName: "Contractual Due" },
    // cardDueAmount: { displayName: "Card Due Amount" },
    // balanceLoaded: { displayName: "Money loaded" },
    // walletUsage: { displayName: "Digital Consumption" },
    // netDueAmount: "Due Amount",

    fromDate: { displayName: "Date", sortable: true },
    busNumber: { displayName: "Bus Number", sortable: true },
    cardDueAmount: { displayName: "Card Due Amount", sortable: true },
    finalProfit: { displayName: "Gross Contribution", sortable: true },
    walletUsage: { displayName: "Digital Consumption", sortable: true },
  },
  // DayWiseDueList table constants
  dayWiseDueList: {
    date: "Created at",
    // balanceLoaded: { displayName: "Money loaded" },
    moneyLoaded: { displayName: "Money Loaded" },
    // cardFeeCash: { displayName: "Card Fee(cash)" },
    walletUsage: { displayName: "Digital Consumption" },
    // cardDue: { displayName: "Card Due" },
    // operatorDueAmount: { displayName: "Contractual Due" },
    contractualDue: { displayName: "Contractual Due" },
    netDueAmount: "Net Due",
    action: "Action",
  },
  // DayWiseDueList table constants
  settlementLedgerList: {
    ledgerDate: "Date",
    // balanceLoaded: { displayName: "Money loaded" },
    dueGeneratedAmount: { displayName: "Due Generated" },
    // cardFeeCash: { displayName: "Card Fee(cash)" },
    operatorPaymentAmount: {
      displayName: "Settled Amount",
      children: {
        transactionId: { displayName: "Transaction ID: ", defaultValue: "N/A" },
      },
    },
    // cardDue: { displayName: "Card Due" },
    // operatorDueAmount: { displayName: "Contractual Due" },
    netDue: { displayName: "Balance / Net Due" },
    detail: "",
  },
  previousSettlemnts: {
    paymentDate: "Settlement Date",
    payment: "Amount",
    type: "Settlement type",
    pendingBalance: "Balance",
    // action: "Action"
  },
  // previous settlement table constants
  previousSettlemntsDetails: {
    busNumber: "Bus Number",
    fromDate: "Travel Date",
    // balanceLoaded: "Money loaded",
    // ^ balanceLoaded key changed to moneyLoaded
    moneyLoaded: "Money Loaded",
    // cardFeeCash: "Card Fee(cash)",
    // ^ cardFeeCash data will be added in moneyLoaded, and this will be removed from here.
    walletUsage: "Digital Consumption",
    // cardDueAmount: "Card Due",
    // ^ cardDueAmount got removed
    // operatorDueAmount: "Contractual Due",
    contractualDue: "Contractual Due",
    netDueAmount: "Net Due",
  },
  previousSettlementsDetailsBD: {
    totalCollection: "Total Collection",
    totalGpsDistance: "GPS Distance(KM)",
    totalIssueTicketByCash: "Cash Ticket",
    totalTicketCount: "Total Ticket Count",
    cashTicketCount: "Cash Ticket Count",
    cashPassengerCount: "Passenger Count",
  },
  pendingDues: {
    cityName: "City",
    operatorName: { displayName: "Operator Name", is_capital: true },
    operatorId: "Operator Id",
    agencyName: "Agency",
    netDueAmount: { displayName: "Net Due", sortable: true },
    action: "Action",
  },
  settledDues: {
    cityName: "City",
    operatorName: { displayName: "Operator Name", is_capital: true },
    operatorId: "Operator Id",
    agencyName: "Agency",
    netDueAmount: { displayName: "Net Due", sortable: true },
    action: "Action",
  },
  vehicleContract: {
    fromDate: "Start Date",
    toDate: "End Date",
    typeOfContract: "Type of Contract",
    borneBy: { displayName: "Collection Handled", is_capital: true },
    subscriptionPlan: { displayName: "Subscription Plan" },
    status: "Status",
    action: "Action",
  },
  operatorVehicleContract: {
    busNumber: "Bus Number",
    fromDate: "Start Date",
    toDate: "End Date",
    typeOfContract: "Type of Contract",
    borneBy: { displayName: "Collection Handled", is_capital: true },
    status: "Status",
    action: "Action",
  },
  settlementGridItems: {
    // lastPendingBalance: { displayName: "Last Balance" },
    settledAmount: { displayName: "Settled Amount" },
    operatorDueAmount: { displayName: "Contractual Due" },
    // cardDueAmount: { displayName: "Card Due" },
    balanceLoaded: { displayName: "Money loaded - Card" },
    walletUsage: { displayName: "Digital Consumption" },
    netDueAmount: { displayName: "Due Amount" },
  },
  // settlement card constants
  dateDetailCardGridItems: {
    moneyLoaded: { displayName: "Money Loaded" },
    walletUsage: { displayName: "Digital Consumption" },
    digitalDiscountByChalo: { displayName: "Chalo Discount Share" },
    contractualDue: { displayName: "Contractual Due" },
    pgFee: { displayName: "PG Fee" },
    netDueAmount: { displayName: "Net Due" },
  },
  netDueCardGridItems: {
    finalNetDue: { displayName: "Net Due" },
  },
  cardCollectionGridItems: {
    balanceLoaded: { displayName: "Money loaded" },
    walletUsage: { displayName: "Digital Consumption" },
    netPayout: { displayName: "Net Payout" },
  },
  collectionGridItems: {
    totalCollection: { displayName: "Total Collection (Rs.)" },
    walletUsage: { displayName: "Digital Consumption", navigationAllowed: "true" },
    expense: { displayName: "Chalo Expenses", isExpandable: true, expandableType: "expensesBreakdown" },
    finalProfit: { displayName: "Gross Contribution" },
    netPayout: { displayName: "Operator's Take" },
  },
  bhopalCollectionGridItems: {
    totalCollection: { displayName: "Total Collection (Rs.)" },
    balanceLoaded: { displayName: "Money loaded (Rs.)", isExpandable: true, expandableType: "moneyLoadedBreakdown" },
    walletUsage: {
      displayName: "Digital Consumption (Rs.)",
      isExpandable: true,
      navigationAllowed: false,
      expandableType: "digitalConsumtionBreakdown",
    },
    finalProfit: { displayName: "Gross Contribution" },
    netPayout: { displayName: "Operator's Take" },
  },
  collectionDetailGridItems: {
    totalCollection: { displayName: "Total Collection (Rs.)" },
    walletUsage: { displayName: "Digital Consumption" },
    expense: { displayName: "Chalo Expenses" },
    finalProfit: { displayName: "Gross Contribution" },
    netPayout: { displayName: "Operator's Take" },
  },
  operatorViewGridItems: {
    averageBuses: { displayName: "Average Buses" },
    totalCollection: { displayName: "Total Collection (Rs.)" },
    balanceLoaded: { displayName: "Money loaded (Rs.)", isExpandable: true, expandableType: "moneyLoadedBreakdown" },
    walletUsage: {
      displayName: "Digital Consumption (Rs.)",
      isExpandable: true,
      expandableType: "digitalConsumtionBreakdown",
    },
    operatorWiseNetPayout: { displayName: "Net Due (Rs.)" },
  },
  agencyViewGridItems: {
    averageBuses: { displayName: "Average Buses" },
    totalCollection: { displayName: "Total Collection (Rs.)" },
    balanceLoaded: { displayName: "Money loaded (Rs.)", isExpandable: true, expandableType: "moneyLoadedBreakdown" },
    walletUsage: {
      displayName: "Digital Consumption (Rs.)",
      isExpandable: true,
      expandableType: "digitalConsumtionBreakdown",
    },
    agencyWiseNetPayout: { displayName: "Net Due (Rs.)" },
  },
  expensesBreakdown: {
    driverSalary: "Driver",
    fuelExpense: "Fuel",
    tollAmount: "Toll",
    associationFee: "Association Fee",
    cleaning: "Cleaning",
    conductorSalary: "Conductor Salary",
    maintenance: "Maintainance",
    penalty: "Penalty",
    helper: "Helper",
    other: "Other",
  },
  finalProfitBreakDown: {
    contractualAmount: "Contractual Amount",
    convenienceFee: "Convenience Fee",
    cardFee: "Card Fee",
    gcEdit: "GC Adjusted",
  },
  moneyLoadedBreakdown: {
    totalRechargeCardSold: "Recharge",
    // totalIssueCardCashAmt: "Card Sold",
    totalPassIssueCashAmt: "Pass Sold",
    // totalRechargeCashAmt: "Recharge",
    cardFee: "Card Fee",
  },
  indoreMoneyLoadedBreakdown: {
    totalRechargeCardSold: "Recharge",
    // totalIssueCardCashAmt: "Card Sold",
    totalPassIssueCashAmt: "Pass Sold",
    // totalRechargeCashAmt: "Recharge",
    cardFee: "Card Fee",
    passIssueProductCost: "Pass Product Cost",
  },
  digitalConsumtionBreakdown: {
    ticketByPrepaidCard: "Wallet Ticket",
    mobileTicketAmount: "Mobile Ticket",
    passIssueProductCost: "Pass Consumption",
    chaloPayAmount: "Chalo Pay",
    ncmcPrepaidAmount: "NCMC Wallet",
    scanPayAmount: "Scan & Pay",
    upiTicketAmount: "UPI",
    mobileTicketResidualAmount: "Unused Mobile Ticket",
  },
  digitalRidership: {
    prepaidPassengerCount: "Wallet",
    mobileticketPassengerCount: "Mobile Ticket",
    mobilepassPassengerCount: "Mobile Pass",
    passPassengerCount: "Card Pass",
    chaloPayPassengerCount: "Chalo Pay",
    ncmcPrepaidPassengerCount: "NCMC Wallet",
    scanpayPassengerCount: "Scan & Pay",
    upiPassengerCount: "UPI",
    // residualPassengerCount: 'Unused Mobile Ticket'
  },
  expenseArray: [
    { name: "driverSalary", label: "Driver" },
    { name: "fuelExpense", label: "Fuel" },
    { name: "tollAmount", label: "Toll" },
    { name: "associationFee", label: "Association Fee" },
    { name: "cleaning", label: "Cleaning" },
    { name: "conductorSalary", label: "Conductor Salary" },
    { name: "maintenance", label: "Maintainance" },
    { name: "penalty", label: "Penalty" },
    { name: "helper", label: "Helper" },
    { name: "other", label: "Other" },
  ],

  contractDetail: {
    revenueShare: "Revenue Share",
    percentageBased: "Percentage Based",
    flatFeeBased: "Flat Fee Based",
    perTicketBased: "Per Ticket Based",
    cashTicketCount: "Cash Ticket Count",
    prepaidTicketCount: "Digital Ticket Count",
    totalTicketCount: "Total Ticket Count",
    totalCollection: "Total Ticket Collection",
    cardCollection: "Total Digital Collection",
    mobileDigitalCollection: "Total Digital Collection",
    cardDigitalCollection: "Total Digital Collection",
    originalDigitalAmount: "Original Digital Amount",
    flatFee: "Flat Fee",
    baseline: "Baseline",
    percentageCriteria: "Collection Type",
    percentage: "Percentage",
    businessGuaranteed: "Business Guarantee",
    perDay: "Per Day",
    perKm: "Per Km",
  },
  roleBasedCollectionGridItems: {
    averageBuses: { displayName: "Average Buses" },
    totalCollection: { displayName: "Total Collection" },
    balanceLoaded: { displayName: "Money loaded", isExpandable: true, expandableType: "moneyLoadedBreakdown" },
    walletUsage: {
      displayName: "Digital Consumption",
      isExpandable: true,
      navigationAllowed: false,
      expandableType: "digitalConsumtionBreakdown",
    },
    netDueAmount: { displayName: "Net Due" },
  },
  IndoreBasedCollectionGridItems: {
    averageBuses: { displayName: "Average Buses" },
    totalCollection: { displayName: "Total Collection" },
    balanceLoaded: {
      displayName: "Money loaded",
      isExpandable: true,
      expandableType: "indoreMoneyLoadedBreakdown",
    },
    walletUsage: {
      displayName: "Digital Consumption",
      isExpandable: true,
      navigationAllowed: false,
      expandableType: "digitalConsumtionBreakdown",
    },
    netDueAmount: { displayName: "Net Due" },
  },
  IndoreBasedOverviewGridItems: {
    averageBuses: { displayName: "Average Buses" },
    totalCollection: { displayName: "Total Collection" },
    ridership: { displayName: "Ridership" },
    // digitalRidership: { displayName: "Digital Ridership" },
    epkm: { displayName: "EPKM" },
    finalProfit: { displayName: "Gross Contribution" },
    // totalIssueCardCashAmt: { displayName: "Card Sold" },
    balanceLoaded: { displayName: "Money loaded", isExpandable: true, expandableType: "indoreMoneyLoadedBreakdown" },
    walletUsage: {
      displayName: "Digital Consumption",
      isExpandable: true,
      navigationAllowed: false,
      expandableType: "digitalConsumtionBreakdown",
    },
    digitalPenetration: { displayName: "Digital Penetration" },
    digitalMeta: { displayName: "Card Products" },
    exitBuses: { displayName: "Exit Buses" },
    totalGpsDistance: { displayName: "Distance (in km)" },
    // mobileProducts :{displayName: "Mobile Products"},
    // digitalPenetrationByAmount: { displayName: "Digital Penetration" },
  },
  roleBasedOverviewGridItems: {
    averageBuses: { displayName: "Average Buses" },
    totalCollection: { displayName: "Total Collection" },
    ridership: { displayName: "Ridership" },
    // digitalRidership: { displayName: "Digital Ridership" },
    epkm: { displayName: "EPKM" },
    finalProfit: { displayName: "Gross Contribution", isExpandable: true, expandableType: "finalProfitBreakDown" },
    // totalIssueCardCashAmt: { displayName: "Card Sold" },
    balanceLoaded: { displayName: "Money loaded", isExpandable: true, expandableType: "moneyLoadedBreakdown" },
    walletUsage: {
      displayName: "Digital Consumption",
      isExpandable: true,
      navigationAllowed: false,
      expandableType: "digitalConsumtionBreakdown",
    },
    digitalPenetration: { displayName: "Digital Penetration" },
    digitalMeta: { displayName: "Card Products" },
    mobileProducts: { displayName: "Mobile Products" },
    exitBuses: { displayName: "Exit Buses" },
    ticketSalesAmount: { displayName: "Mobile Ticket Sales" },
    passSalesAmount: { displayName: "Mobile Pass Sales" },
    totalGpsDistance: { displayName: "Distance (in km)" },
    onlineRecharge: { displayName: "Online Recharges" },
    digitalDiscountByChalo: { displayName: "Chalo Discount Share" },
    // digitalPenetrationByAmount: { displayName: "Digital Penetration" },
    amountSettled: { displayName: "Amount Settled" },
    currentOutstanding: { displayName: "Current Outstanding" },
  },
  reportsModule: {
    reportType: "Report Type",
    fromDate: "From Date",
    toDate: "To Date",
    createdAt: "Requested On",
    generatedAt: "Updated On",
    storageKey: "Download Report",
  },
};

export const roleBasedHiddenItems = {
  [roles.agencyManager]: ["finalProfit", "exitBuses", "digitalDiscountByChalo", "amountSettled", "currentOutstanding"],
  [roles.operator]: ["ticketSalesAmount", "passSalesAmount", "digitalDiscountByChalo"],
};

export const UserFormRoles = {
  admin: "admin",
  others: "others",
};

export const MessageType = {
  ERROR: "error",
  SUCCESS: "success",
};

export const messages = {
  user_info_error: "Failed to get user from server",
  auth_token_error: "Failed to get auth token from server.",
  google_code_error: "Failed to get code from google services",
};

export const amountFields = {
  walletUsage: 0,
  pendingBalance: 0,
  cardDueAmount: 0,
  operatorDueAmount: 0,
  contractualDue: 0,
  balanceLoaded: 0,
  moneyLoaded: 0,
  finalProfit: 0,
  netPayout: 0,
  totalCollection: 0,
  epkm: 0,
  expense: 0,
  totalRechargeCardSold: 0,
  totalPassIssueCashAmt: 0,
  cardFee: 0,
  netDueAmount: 0,
  digitalConsumptionByChalo: 0,
  passIssueProductCost: 0,
  ticketByPrepaidCard: 0,
  mobileTicketResidualAmount: 0,
  mobileTicketAmount: 0,
  scanPayAmount: 0,
  upiTicketAmount: 0,
  driverSalary: 0,
  associationFee: 0,
  tollAmount: 0,
  cleaning: 0,
  conductorSalary: 0,
  maintenance: 0,
  penalty: 0,
  helper: 0,
  agencyWiseNetPayout: 0,
  other: 0,
  passSalesRevenue: 0,
  ticketSalesAmount: 0,
  passSalesAmount: 0,
  totalGpsDistance: 0,
  onlineRecharge: 0,
  chaloPayAmount: 0,
  ncmcPrepaidAmount: 0,
  digitalDiscountByChalo: 0,
  contractualAmount: 0,
  convenienceFee: 0,
  gcEdit: 0,
};

export const defaultValueZero = {
  totalTicketCount: true,
  totalGpsDistance: true,
  cardDueAmount: true,
  totalPassengerCount: true,
  totalTravel: true,
  numberOfTrips: true,
  walletUsage: true,
  balanceLoaded: true,
  moneyLoaded: true,
  digitalConsumptionByChalo: true,
  finalProfit: true,
  netPayout: true,
  totalCollection: true,
  epkm: true,
  expense: true,
  operatorDueAmount: true,
  contractualDue: true,
  totalRechargeCardSold: true,
  totalPassIssueCashAmt: true,
  cardFee: true,
  netDueAmount: true,
  passIssueProductCost: true,
  ticketByPrepaidCard: true,
  mobileTicketResidualAmount: true,
  mobileTicketAmount: true,
  scanPayAmount: true,
  upiTicketAmount: true,
  driverSalary: true,
  associationFee: true,
  tollAmount: true,
  cleaning: true,
  conductorSalary: true,
  maintenance: true,
  penalty: true,
  helper: true,
  other: true,
  cardFeeCash: true,
  passSalesRevenue: true,
  ticketSalesAmount: true,
  passSalesAmount: true,
  chaloPayAmount: true,
  ncmcPrepaidAmount: true,
  conductorIncentives: true,
  driverIncentives: true,
  staffFuel: true,
  conductorAdvance: true,
  driverAdvance: true,
  challan: true,
  tollTax: true,
  maintenanceExpense: true,
  conductorSalaryExpense: true,
  driverSalaryExpense: true,
  fuelExpenses: true,
  officeExpenses: true,
  stationary: true,
  miscExpenses: true,
  accidentalSettlements: true,
  busCleaning: true,
  cardPassRefund: true,
  conductorOvertime: true,
  driverOvertime: true,
  rtoExpenses: true,
  busEmi: true,
  contractualAmount: true,
  gcEdit: true,
  convenienceFee: true,
};

export const defaultValueNa = {
  settlementDistance: true,
};

export const doubleFields = {
  digitalPenetration: {
    Amount: { displayName: "Amount" },
    Ridership: { displayName: "Ridership" },
  },
  ridership: {
    totalRidership: { displayName: "Total" },
    digitalRidership: { displayName: "Digital", isExpandable: true, expandableType: "digitalRidership" },
  },
  digitalMeta: {
    cardsSold: { displayName: "Cards Sold" },
    passesSold: { displayName: "Passes Sold" },
    rechargesDone: { displayName: "Recharges" },
  },
  mobileProducts: {
    mobileTicketsSold: { displayName: "Mobile Ticket" },
    mobilePassesSold: { displayName: "Mobile Pass" },
    mobileRechargesDone: { displayName: "Online Recharges" },
  },
  amountSettled: {
    amountPaid: { displayName: "Amount Paid" },
    amountReceived: { displayName: "Amount Received" },
  },
  currentOutstanding: {
    toBePaid: { displayName: "To Be Paid" },
    toBeReceived: { displayName: "To Be Received" },
  },
};

export const checkedFields = {
  multiple_type_checked: "*Please select either live or not live record",
  select_only_one_live: "*Please select only one live record to edit",
  edit_contracts_running_waybill: "*Please select contracts that don't have running waybills",
};

export const dateFields = {
  contractualDate: 1,
  digitalDate: 1,
  paymentDate: 1,
  date: 1,
  fromDate: 1,
  toDate: 1,
};

export const rupeeSymbol = {
  mobileTicketAmount: true,
};

export const contractTypeKeys = {
  ff: "flatFee",
  rs: "revenueShare",
  bl: "baseline",
  bg: "businessGuaranteed",
  flatfee: "flatFee",
  revenueshare: "revenueShare",
  baseline: "baseline",
  businessguaranteed: "businessGuaranteed",
};

export const ModeAndPercentage = {
  mobileDigitalCollection: "Mobile",
  cardDigitalCollection: "Card",
};

export const DaysIncluded = {
  calendarDays: "Calendar days",
  waybillDays: "Waybill days",
};

export const operatorTypes = [
  {
    label: "Kiosk OTP", type: "featureConfigs", config: "kioskPassword", target: "operator",
  },
  {
    label: "Live Camera", type: "navBarConfig", config: "LiveCamera",
  },
  {
    label: "ETIM", type: "enabledSystems", config: "etim",
  },
  {
    label: "GPS", type: "enabledSystems", config: "gps",
  },
  {
    label: "Camera", type: "enabledSystems", config: "camera",
  },
];
